








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Footer extends Vue {
  @Prop({ type: Boolean, default: false }) light!: boolean

  get className() {
    return !this.light ? 'footer__inner' : 'footer__inner--light'
  }
}
